import styled from "styled-components";

import { Flex, Text } from "@similarweb/ui-components/foundations";

export const NoTouchPurchasePaymentFailureContainer = styled(Flex)`
    flex-direction: column;
    align-items: center;
    gap: 36px;
    height: 100%;
    padding: 24px 43px 36px;
`;

export const NoTouchPurchasePaymentFailureCloseButtonContainer = styled(Flex)`
    position: absolute;
    top: 12px;
    right: 12px;
`;

export const NoTouchPurchasePaymentFailureIllustration = styled.img`
    width: 140px;
    height: 140px;
`;

export const NoTouchPurchasePaymentFailureHelpLine = styled.div`
    text-align: center;
`;

export const NoTouchPurchasePaymentFailureContactButton = styled.button`
    display: contents;
`;

export const NoTouchPurchasePaymentFailureContactLinkText = styled(Text)`
    font-weight: 700;
`;
